export default __webpack_public_path__ + "static/featured-image-mvp-development-cedfee6cba6ee7c8cdb67fe2ffa9b194.jpg";